const PLACEHOLDER = "unknown";

/** A displayable given name. Drops blanks and the User create placeholder. */
export function usableGivenName(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (!trimmed || trimmed.toLowerCase() === PLACEHOLDER) return "";
  return trimmed;
}

/**
 * Full display name. Drops the User create placeholder on each token.
 * "Unknown Unknown" is empty. A real token next to a placeholder stays.
 */
export function usablePersonName(value: string | null | undefined): string {
  return (value ?? "")
    .split(/\s+/)
    .map((part) => part.trim())
    .filter((part) => part && part.toLowerCase() !== PLACEHOLDER)
    .join(" ");
}
